__turbopack_context__.v({
  "action": "dock-module__5MfeuW__action",
  "actionBtn": "dock-module__5MfeuW__actionBtn",
  "badge": "dock-module__5MfeuW__badge",
  "cluster": "dock-module__5MfeuW__cluster",
  "dock": "dock-module__5MfeuW__dock",
  "icon": "dock-module__5MfeuW__icon",
  "item": "dock-module__5MfeuW__item",
  "label": "dock-module__5MfeuW__label",
  "podAccent": "dock-module__5MfeuW__podAccent",
  "podCircle": "dock-module__5MfeuW__podCircle",
  "podGroup": "dock-module__5MfeuW__podGroup",
  "podItem": "dock-module__5MfeuW__podItem",
  "podShape": "dock-module__5MfeuW__podShape",
  "podShapeSlot": "dock-module__5MfeuW__podShapeSlot",
  "podWord": "dock-module__5MfeuW__podWord",
  "podWordSlot": "dock-module__5MfeuW__podWordSlot",
  "spring": "dock-module__5MfeuW__spring",
});
